import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-clear-all-filters', {
    height: '23px',
    lineHeight: '23px',
    padding: '0 18px',
});

cssRule('.tb-search-filter', {
    height: '23px',
    lineHeight: '23px',
    padding: '0 18px',
});

cssRule('.tb-filter-section', {
    paddingTop: '12px',
});

cssRule('.tb-filter-section-with-border', {
    paddingTop: '12px',
    marginTop: '12px',
    borderTop: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
});

cssRule('.tb-filter-section-header', {
    borderTop: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
    padding: '9px 18px',
    fontSize: '15px',
    fontWeight: 'normal',
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-filter-checkboxes', {
    paddingTop: '12px',
});

cssRule('.tb-filter-checkboxes .tb-filter', {
    padding: '0 18px 6px',
});

cssRule('.tb-filter', {
    padding: '3px 18px 0',
});

cssRule('.tb-filter-label', {
    display: 'block',
    lineHeight: '23px',
    position: 'relative',
});

cssRule('.tb-filter-popup-menu-button-text', {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

cssRule('.tb-clear-link', {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 'auto',
    lineHeight: '23px',
});

cssRule('.tb-filter-panel-dropdown', {
    height: '320px',
});

